import { usePermission } from "../hooks/usePermissions";
import type { FeatureKey } from "../permissions/permissions.config";


interface PermissionGateProps {
  feature?: FeatureKey;
  permissions?: string[];
  mode?: "all" | "any";
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export function PermissionGate({
  feature,
  permissions,
  mode = "all",
  fallback = null,
  children,
}: PermissionGateProps) {
  const allowed = usePermission(
    feature ?? permissions ?? [],
    mode
  );

  return allowed ? <>{children}</> : <>{fallback}</>;
}